import { ABEnabledContainer } from "@/components/ABEnabledContainer";
import FileRequestModal from "@/containers/Parlor/ParlorDetailContainer/components/Modal/FileRequestModal";
import { EventPathType } from "goi_common";

// 실험 #307 (시설류) / #308 (가이드북·리뷰류): FileRequestModal 추가정보 라디오(B) A/B 테스트.
// 302(NotLoginFileRequestModal)와 동일한 ABEnabledContainer 패턴.
// 페이지 구분은 exp_page를 experiment_exposure properties로 실어 GA4에서 분해(이벤트명 40자 제한 무관).
// Hackle 전환 측정은 기존 file_request_mdl-submit_success가 그대로 담당.
export const EXP_KEY_307_FACILITY = 307;
export const EXP_KEY_308_GUIDE = 308;

export type ExperimentFileRequestPage =
  | "parlor"
  | "parlor_list"
  | "parlor_prices"
  | "region"
  | "crematorium"
  | "seaburial"
  | "facilities_region"
  | "review"
  | "gdb_tip"
  | "guidebook"
  | "funeral_prepare";

const EXP_PAGE_TO_KEY: Record<ExperimentFileRequestPage, number> = {
  parlor: EXP_KEY_307_FACILITY,
  parlor_list: EXP_KEY_307_FACILITY,
  parlor_prices: EXP_KEY_307_FACILITY,
  region: EXP_KEY_307_FACILITY,
  crematorium: EXP_KEY_307_FACILITY,
  seaburial: EXP_KEY_307_FACILITY,
  facilities_region: EXP_KEY_307_FACILITY,
  review: EXP_KEY_308_GUIDE,
  gdb_tip: EXP_KEY_308_GUIDE,
  guidebook: EXP_KEY_308_GUIDE,
  funeral_prepare: EXP_KEY_308_GUIDE,
};

interface ExperimentFileRequestModalProps {
  isOpen: boolean;
  onClose: () => void;
  path: keyof typeof EventPathType;
  expPage: ExperimentFileRequestPage;
}

export default function ExperimentFileRequestModal({
  expPage,
  ...props
}: ExperimentFileRequestModalProps) {
  return (
    <ABEnabledContainer
      experimentKey={EXP_PAGE_TO_KEY[expPage]}
      contextExtra={{ exp_page: expPage }}
      ComponentA={<FileRequestModal {...props} />}
      ComponentB={<FileRequestModal {...props} isAdditionalInfoSelect />}
    />
  );
}
